import { ThreeDots } from '@agney/react-loading'

import appSettings from '@/config/appSettings'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Spinner = ThreeDots as any

const Loading = () => (
  <div className='flex min-h-screen items-center justify-center'>
    <div className='flex flex-col items-center justify-center'>
      <img
        src={appSettings.logo}
        alt={`${appSettings.name} logo`}
        className='mx-auto mb-8 h-24 w-auto rounded-lg'
      />
      <div className='text-text-tertiary'>
        <Spinner width={84} />
      </div>
    </div>
  </div>
)

export default Loading
